<template>
  <b-row
    :class="customChange ? 'list-group-item' : ''"
  >
    <b-col
      md="12"
      xl="12"
    >
      <b-overlay
        id="overlay-background"
        :show="installmentloader"
        variant="dark"
        opacity="0.85"
        blur="2px"
        rounded="sm"
        spinner-variant="primary"
        spinner-medium
      >
        <b-card>
          <b-card-header
            class="installment-plan-header"
          >
            <b-card-title>{{ $t('DEBTIA_INSTALLMENT_PLAN') }}</b-card-title>
          </b-card-header>
          <b-card-body
            class="installment-plan-body"
          >
            <div
              v-if="installmentData.length > 0"
              class="scroll-div-installment"
            >
              <b-table
                :fields="installmentTableFields"
                :items="installmentData"
                striped
              >
                <template #cell(amount)="row">
                  {{ `${formatCurrency(row.item.installment_amount, defaultCurrency)}` }}
                </template>
                <template #cell(interest)="row">
                  {{ `${formatCurrency(row.item.interest, defaultCurrency)}` }}
                </template>
                <template #cell(remaining_amount)="row">
                  {{ `${formatCurrency(row.item.remaining_amount, defaultCurrency)}` }}
                </template>
                <template #cell(status)="row">
                  <b-badge
                    :variant="row.item.is_paid ? 'success' : 'warning'"
                    class="badge-glow"
                  >
                    {{ row.item.is_paid ? $t('DEBTIA_PAID') : $t('DEBTIA_NOT_PAID') }}
                  </b-badge>
                </template>
              </b-table>
            </div>
            <b-alert
              v-else
              variant="warning"
              show
            >
              <div class="alert-body">
                {{ $t('DEBTIA_NO_PLAN_GENERATED_MSG') }}
              </div>
            </b-alert>
          </b-card-body>
        </b-card>
      </b-overlay>
    </b-col>
  </b-row>
</template>

<script>
import {
  BRow, BCol, BCard, BCardHeader, BCardTitle, BAlert, BTable, BCardBody, BOverlay,
  BBadge,
} from 'bootstrap-vue'
// import store from '@/store'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import Ripple from 'vue-ripple-directive'
import constants from '@/app-configs/constants'
import i18n from '@/libs/i18n'
import { EventBus } from '@/event-bus'
import axios from '@axios'
// import DragLinks from '../DragLinks.vue'

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BAlert,
    BTable,
    BCardHeader,
    BCardTitle,
    BCardBody,
    BOverlay,
    // eslint-disable-next-line vue/no-unused-components
    ToastificationContent,
    BBadge,
    // DragLinks,
  },
  directives: {
    Ripple,
  },
  props: {
    side: {
      type: String,
      required: true,
    },
    customChange: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      constants,
      installmentloader: false,
      installmentData: [],
      installmentplanstatus: 404,
      userType: JSON.parse(localStorage.getItem('userData')).data.user_type,
      isSuperAdmin: false,
      caseId: this.$route.params.id,
      defaultCurrency: localStorage.getItem('defaultCurrency'),
    }
  },
  computed: {
    installmentTableFields() {
      return [
        { key: 'installment_date', label: i18n.t('DEBTIA_INSTALLMENT_DATE') },
        { key: 'interest', label: i18n.t('DEBTIA_INSTALLMENT_INTEREST') },
        { key: 'amount', label: i18n.t('DEBTIA_AMOUNT') },
        { key: 'remaining_amount', label: i18n.t('DEBTIA_REMAINING_AMOUNT') },
        { key: 'status', label: i18n.t('DEBTIA_STATUS') },
      ]
    },
  },
  // setup() {
  //   const { installmentData, installmentplanstatus, userType } = store.state['case-details']
  //   let isSuperAdmin = false
  //   if (userType === 'super-admin') {
  //     isSuperAdmin = true
  //   } else {
  //     isSuperAdmin = false
  //   }
  //   return {
  //     installmentData,
  //     installmentplanstatus,
  //     isSuperAdmin,
  //   }
  // },
  created() {
    this.getInstallmentPlans()
    this.getIsSuperAdmin()
  },
  methods: {
    formatCurrency(amount, defaultCurrency) {
      return new Intl.NumberFormat('da-DK', { style: 'currency', currency: defaultCurrency }).format(parseFloat(amount).toFixed(2))
    },
    getIsSuperAdmin() {
      if (this.userType === 'super-admin') {
        this.isSuperAdmin = true
      } else {
        this.isSuperAdmin = false
      }
    },
    async getInstallmentPlans() {
      await axios.get(`https://api.betaling.weiswiseapps.com/api/v1/installment_plan/get_installments?journal_id=${this.caseId}`).then(response => {
        if (response.status) {
          this.installmentData = response.data.data.installments_data
          this.installmentplanstatus = response.data.data.plan_status
          EventBus.$emit('getInstallmentPlanStatus', this.installmentplanstatus)
        }
      }).catch(() => {
        this.installmentData = []
        this.installmentplanstatus = 404
        EventBus.$emit('getInstallmentPlanStatus', this.installmentplanstatus)
      })
    },
    confirmText() {
      this.$swal({
        title: i18n.t('DEBTIA_SURE'),
        text: i18n.t('DEBTIA_REVERT_MSG'),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: i18n.t('DEBTIA_YES'),
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          this.installmentloader = true
          axios.post(`${constants.paymentsBaseUrl}/installment_plan/update_status`, {
            journal_id: this.caseId,
            status: -1,
          }).then(response => {
            if (response.status === 200) {
              this.installmentloader = false
              this.installmentplanstatus = 3
              this.$swal({
                icon: 'success',
                title: 'Deleted!',
                text: i18n.t('DEBTIA_PLAN_CANCELLATION_SUCCESS'),
                customClass: {
                  confirmButton: 'btn btn-success',
                },
              })
              this.getInstallmentPlans()
            }
          })
        }
      })
    },
  },
}
</script>

<style lang="scss">
.scroll-div-installment {
  overflow-y: scroll;
  /* Ensure the inner div doesn't exceed the container */
  max-height: 400px;
  padding-right: 10px;
}

.scroll-div-installment::-webkit-scrollbar {
    width: 12px;
}

.scroll-div-installment::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
    border-radius: 10px;
}

.scroll-div-installment::-webkit-scrollbar-thumb {
    border-radius: 10px;
    -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.5);
}
</style>
